
export class GeocodingUtil {
    public static isEnable(): boolean {
        if (navigator?.geolocation) {
            return true;
        }

        return false;
    }

    public static getGeolocation(successCallback: PositionCallback, errorCallback: PositionErrorCallback): void {
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    }
}